import React, { useRef } from "react";
import MButton from "./MButton";
import { enqueueSnackbar } from "notistack";

export default function MFieldImage({ name, image, lastImage, onChange }) {
  const fileRef = useRef();

  const onUploadImage = async (e) => {
    if (e.target.files[0]) {
      onChange(e.target.files[0]);
    } else {
      enqueueSnackbar("Some error in selected file", { variant: "error" });
      onChange(null);
    }
  };
  return (
    <div className="add-field-image">
      <span>{name}</span>
      <div className="field-image-box">
        <img src={image ? URL.createObjectURL(image) : lastImage ? lastImage : "https://blocks.astratic.com/img/general-img-square.png"} />
        <input
          accept="image/*"
          id="file-iploader"
          type="file"
          hidden
          onChange={onUploadImage}
          ref={fileRef}
        />
        <MButton
          onClick={() => fileRef.current.click()}
          label={lastImage ? "Change Image" : "Upload Image"}
          color="secondary"
        />
      </div>
    </div>
  );
}
